document.addEventListener("variant:change", function(event) {
  const variant = event.detail.variant;
  const priceBox = document.querySelector(".product-price-box");

  if (variant && priceBox) {
    const currentPrice = variant.price;
    const comparePrice = variant.compare_at_price;

    // Clear existing discount
    let discountTag = priceBox.querySelector(".discount-tag");
    if (discountTag) discountTag.remove();

    if (comparePrice && comparePrice > currentPrice) {
      const discount = Math.round(((comparePrice - currentPrice) / comparePrice) * 100);

      discountTag = document.createElement("span");
      discountTag.classList.add("discount-tag");
      discountTag.textContent = `${discount}% OFF`;

      priceBox.appendChild(discountTag);
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const searchBtn = document.querySelector(".header__column--right .custom_search_btn_main");
  const searchBox = document.querySelector(".header__column--right .custom-secrch-main");
  const closeBtn = document.querySelector(".header__column--right .predictive-search__close-modal-button");
  if (searchBtn && searchBox) {
    // console.log(searchBtn, " searchBtn");
    searchBtn.addEventListener("click", function() {
      searchBox.classList.add("search_active");
    });
  }
  if (closeBtn && searchBox) {
    closeBtn.addEventListener("click", function() {
      searchBox.classList.remove("search_active");
    });
  }
  const msearchBtn = document.querySelector(".header__column--left .custom_search_btn_main");
  const msearchBox = document.querySelector(".header__column--left .custom-secrch-main");
  const mcloseBtn = document.querySelector(".header__column--left .predictive-search__close-modal-button");
  if (msearchBtn && msearchBox) {
    // console.log(msearchBtn, " searchBtn");
    msearchBtn.addEventListener("click", function() {
      msearchBox.classList.add("search_active");
    });
  }
  if (mcloseBtn && msearchBox) {
    mcloseBtn.addEventListener("click", function() {
      msearchBox.classList.remove("search_active");
    });
  }
});